import cx from 'classnames';
import { motion } from 'motion/react';

type BaseCardProps = {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
  className?: string;
  unpadded?: boolean;
  headerRightComponent?: React.ReactNode;
};

export default function BaseCard({
  children,
  title,
  subtitle,
  className,
  unpadded = false,
  headerRightComponent,
}: BaseCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.6, y: 50 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{
        duration: 0.6,
        scale: { type: 'spring', visualDuration: 0.6, bounce: 0.2 },
      }}
      className={cx(`overflow-hidden rounded-2xl bg-white`, className)}
    >
      <header className="bg-primary flex items-center justify-between px-6 py-3 text-neutral-100">
        <div>
          <h2 className="text-xl font-bold">{title}</h2>
          <h4 className="text-sm font-normal italic">{subtitle}</h4>
        </div>
        {headerRightComponent}
      </header>
      {unpadded ? children : <div className="px-8 pb-6 pt-4">{children}</div>}
    </motion.div>
  );
}
